import { CDPHooksProvider } from "@coinbase/cdp-hooks";
import type { ReactNode } from "react";
import { env } from "../env";

/**
 * All direct usage of `@coinbase/cdp-core` / `@coinbase/cdp-hooks` in this app is confined
 * to `src/lib/coinbase/**`. If the Coinbase package names or config shape change, this is
 * the one file (plus its sibling hooks) that needs to change — see COINBASE_INTEGRATION_NOTES.md.
 *
 * `ethereum.createOnLogin: "smart"` provisions a Smart Account (ERC-4337) on first sign-in
 * so batched approve+fundEscrow user operations and Paymaster sponsorship are available.
 */
export function CdpProvider({ children }: { children: ReactNode }) {
  return (
    <CDPHooksProvider
      config={{
        projectId: env.VITE_CDP_PROJECT_ID,
        ethereum: { createOnLogin: "smart" },
      }}
    >
      {children}
    </CDPHooksProvider>
  );
}
